import { format, parseISO } from 'date-fns';
import { enUS } from 'date-fns/locale';

// Date format following date-fns patterns https://date-fns.org/v2.17.0/docs/format
export var FULL_MONTH_AND_DAY = 'MMMM d';
export var FULL_MONTH_AND_DAY_AND_YEAR = 'MMMM d, yyyy';
/**
 * Convert an ISO date into a specified format for a provided locale (defaults to enUS Locale)
 * @param dateISO Date string to be formatted, provided in format "YYYY-MM-DD"
 * @param dateFormat The format to be used in the returned date, following date-fns patterns https://date-fns.org/v2.17.0/docs/format
 * @param dateLocale The locale to be used in the returned date (optional,  defaults to enUS)
 */
export var getFormattedDate = function getFormattedDate(_ref) {
  var dateISO = _ref.dateISO,
    dateFormat = _ref.dateFormat,
    _ref$dateLocale = _ref.dateLocale,
    dateLocale = _ref$dateLocale === void 0 ? enUS : _ref$dateLocale;
  try {
    return format(parseISO(dateISO), dateFormat, {
      locale: dateLocale
    });
  } catch (_unused) {
    return 'Invalid DateTime'; //Luxon returned string instead of error for invalid DateTime
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/utils/DateTimeUtil.js
// module id = 4718
// module chunks = 11